import { FC } from 'react';
import { useClassNamesWithStyle } from '@edikk-edikk/country-frontend';
import { useHomeContext } from '#home/hooks';
import homeTitleCss from './assets/home-title.module.scss';

const HomeTitle: FC = () => {
  const { seo } = useHomeContext();
  const classNamesWithStyle = useClassNamesWithStyle();

  return (
    <h1
      className={classNamesWithStyle(
        homeTitleCss.homeTitle,
        homeTitleCss.homeTitle_styleDefault,
        homeTitleCss.homeTitle_styleRed,
      )}
    >
      {seo.h1}
    </h1>
  );
};

export { HomeTitle };
